import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = {
  campaigns: [],
  campaign: {},
  patients: [],
  campaignHistory: [],
  campaignFormInitial: {},
  meta: { pagination: {} },
  saving: false,
  loading: false,
  editing: false
}

let changes = null;
let campaigns = [];
let campaignsData = [];
let updatedRecord = {};
export default function campaignsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}CAMPAIGNS_LOAD_PENDING`:
    case `${PARENT}CAMPAIGN_LOAD_PENDING`:
    case `${PARENT}CAMPAIGN_PATIENTS_LOAD_PENDING`:
      return { ...state, loading: true };

    case `${PARENT}CAMPAIGN_CREATE_PENDING`:
    case `${PARENT}CAMPAIGN_DUPLICATE_PENDING`:
    case `${PARENT}CAMPAIGN_UPDATE_PENDING`:
    case `${PARENT}CAMPAIGN_DELETE_PENDING`:
      return { ...state, saving: true };

    case `${PARENT}CAMPAIGN_LOAD_REJECTED`:
    case `${PARENT}CAMPAIGNS_LOAD_REJECTED`:
    case `${PARENT}CAMPAIGN_CREATE_REJECTED`:
    case `${PARENT}CAMPAIGN_UPDATE_REJECTED`:
    case `${PARENT}CAMPAIGN_DELETE_REJECTED`:
    case `${PARENT}CAMPAIGN_TEMPLATE_MEDIA_UPLOAD_REJECTED`:
    case `${PARENT}CAMPAIGN_DUPLICATE_REJECTED`:
    case `${PARENT}CAMPAIGN_PATIENTS_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false,
        loading: false
      }
      return { ...state, ...changes };

    case `${PARENT}SEND_TEST_EMAIL_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGNS_LOAD_FULFILLED`:
    case `${PARENT}CAMPAIGN_LOAD_FULFILLED`:
    case `${PARENT}CAMPAIGN_PATIENTS_LOAD_FULFILLED`:
      changes = {
        loading: false,
        ...response
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        saving: false,
        ...response
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      if (response.meta.is_list_update) {
        // Update campaign if update from Listing module
        campaigns = [...state.campaigns];
        updatedRecord = response.campaign;
        for (const [index, campaign] of campaigns.entries()) {
          if (campaign.id === updatedRecord.id) {
            campaignsData = [...campaigns.slice(0, index), updatedRecord, ...campaigns.slice(index + 1)];
          }
        }
        changes = {
          campaigns: campaignsData,
          saving: false
        };
      }
      else {
        changes = {
          ...response,
          saving: false
        }
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_DUPLICATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        saving: false,
        campaigns: [response.campaign, ...state.campaigns],
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      campaigns = [...state.campaigns];
      for (const [index, campaign] of campaigns.entries()) {
        if (campaign.id === response.campaign.id) {
          campaigns.splice(index, 1);
        }
      }
      changes = { campaigns: campaigns, ...response }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_RESET`:
      changes = {
        campaign: {}
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_EDIT`:
      changes = {
        editing: action.data,
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_EDIT_CANCEL`:
      changes = {
        editing: false,
        campaignFormInitial: {}
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_PATIENTS_RESET`:
      changes = {
        patients: []
      }
      return { ...state, ...changes };

    case `${PARENT}CAMPAIGN_FORM_INITIALS`:
      changes = {
        campaignFormInitial: action.data,
      }
      return { ...state, ...changes };

    default:
      return state;
  }
}